import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["children", "className", "tabId"];
import React from "react";
import PropTypes from "prop-types";
import { O2TabsContext } from "./o2-tabs-context";

function O2TabsPane(props) {
  var children = props.children,
      className = props.className,
      tabId = props.tabId,
      attributes = _objectWithoutPropertiesLoose(props, _excluded);

  return /*#__PURE__*/React.createElement(O2TabsContext.Consumer, null, function (_ref) {
    var activeTabId = _ref.activeTabId;
    return /*#__PURE__*/React.createElement("div", _extends({}, attributes, {
      className: className,
      style: {
        display: activeTabId === tabId ? '' : 'none'
      }
    }), children);
  });
}

O2TabsPane.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  tabId: PropTypes.any
};
export default O2TabsPane;